import { render } from "./registerCom.vue?vue&type=template&id=320aa383&scoped=true"
import script from "./registerCom.vue?vue&type=script&lang=js"
export * from "./registerCom.vue?vue&type=script&lang=js"

import "./registerCom.vue?vue&type=style&index=0&id=320aa383&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320aa383"]])

export default __exports__